import React from 'react';
import {Link, useHistory} from 'react-router-dom';

function NotFound () {
    let history = useHistory();
        return (
        <div>
            <h2>Error 404 page not found</h2>
            <h1><Link to="/">Return to home menu</Link></h1>
            <p> The current URL is: {history.location.pathname}</p>
            <p> The last action was: {history.action}</p>
        </div>
      )
    
}

export default NotFound;